import React from 'react';
import { DEGREE_LIST } from '../../constants/props';
import List from '../common/list';
import Degree from '../degree';

const Degrees = ({ edit, degrees, onDelete }) => {
  return (
    <List
      title="Degrees"
      list={degrees}
      item={(degree) => <Degree key={degree.hash} edit={edit} {...degree} onDelete={onDelete} />}
    />
  );
};

Degrees.propType = {
  DEGREE_LIST,
};

export default Degrees;
